import initialState from '../core/initialState';
import Event from '../core/Event';
import EstimationProductsReceived from './events/EstimationProductsReceived';
import { ProductState } from './State';
import ProductsAttributesReceived from './events/ProductsAttributesReceived';
import OrderProductsReceived from './events/OrderProductsReceived';
import ChannelNodesReceived from './events/ChannelNodesReceived';
import Channel from '../../domain/Channel';
import EstimationProductsGetRequested from './events/EstimationProductsGetRequested';
import OrderProductsGetRequested from './events/OrderProductsGetRequested';
import EstimationProductsGetFailed from './events/EstimationProductsGetFailed';
import OrderProductsGetFailed from './events/OrderProductsGetFailed';
import EstimationProductsSearchRequested from '../estimations/events/EstimationProductsSearchRequested';
import EstimationsFilterSelected from '../order/events/EstimationsFilterSelected';
import EstimationsFilterRemoved from '../order/events/EstimationsFilterRemoved';
import OrderProductsNextRequested from './events/OrderProductsNextRequested';
import OrderProductsPrevRequested from './events/OrderProductsPrevRequested';
import OrderProductsSearchRequested from '../order/events/OrderProductsSearchRequested';
import OrdersFilterSelected from '../order/events/OrdersFilterSelected';
import OrdersFilterRemoved from '../order/events/OrdersFilterRemoved';
import EstimationProductsPrevRequested from './events/EstimationProductsPrevRequested';
import EstimationProductsNextRequested from './events/EstimationProductsNextRequested';

export default (state: ProductState = initialState.products, anyEvent: Event): ProductState => {
    switch (anyEvent.type) {
        case ChannelNodesReceived.type:
            return {
                ...state,
                channels: (anyEvent as ChannelNodesReceived).channels.sort((channel1: Channel, channel2: Channel) => {
                    return channel1.sortOrder - channel2.sortOrder;
                })
            };

        case EstimationProductsGetRequested.type:
        case OrderProductsGetRequested.type:
            return {
                ...state,
                productsLoader: true
            };
        case OrderProductsNextRequested.type: {
            return {
                ...state,
                orderProductsCursorIndex: state.orderProductsCursorIndex + 1
            };
        }
        case OrderProductsPrevRequested.type: {
            return {
                ...state,
                orderProductsCursorIndex: state.orderProductsCursorIndex - 1
            };
        }
        case OrderProductsSearchRequested.type:
        case OrdersFilterSelected.type:
        case OrdersFilterRemoved.type: {
            return {
                ...state,
                orderProductsCursorIndex: 0,
                orderProductsCursors: []
            };
        }
        case EstimationProductsNextRequested.type: {
            return {
                ...state,
                estimationProductCursorIndex: state.estimationProductCursorIndex + 1
            };
        }
        case EstimationProductsPrevRequested.type: {
            return {
                ...state,
                estimationProductCursorIndex: state.estimationProductCursorIndex - 1
            };
        }
        case EstimationProductsSearchRequested.type:
        case EstimationsFilterSelected.type:
        case EstimationsFilterRemoved.type: {
            return {
                ...state,
                estimationProductCursorIndex: 0,
                estimationProductsCursors: []
            };
        }
        case EstimationProductsReceived.type: {
            const c = [...state.estimationProductsCursors];
            c[state.estimationProductCursorIndex + 1] = (anyEvent as EstimationProductsReceived).products.cursor;
            return {
                ...state,
                estimationProducts: (anyEvent as EstimationProductsReceived).products.products,
                estimationProductsCursors: c,
                productsLoader: false
            };
        }
        case OrderProductsReceived.type: {
            const c = [...state.orderProductsCursors];
            c[state.orderProductsCursorIndex + 1] = (anyEvent as OrderProductsReceived).products.cursor;
            return {
                ...state,
                orderProducts: (anyEvent as OrderProductsReceived).products.products,
                orderProductsCursors: c,
                productsLoader: false
            };
        }
        case EstimationProductsGetFailed.type:
        case OrderProductsGetFailed.type: {
            return {
                ...state,
                productsLoader: false
            };
        }
        case ProductsAttributesReceived.type:
            const event: ProductsAttributesReceived = anyEvent as ProductsAttributesReceived;
            return {
                ...state,
                ...event.searchableAttributes
            };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/application/products/reducer.ts